module.exports = __webpack_public_path__ + "img/mal_small.8d12f957.png";